import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { AuthProvider } from './contexts/AuthContext';
import { PageConfigProvider } from './contexts/PageConfigContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthenticatedRoute } from './components/AuthenticatedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages';
import { OrdersPage, OrdersSettingsPage, OrderStatistics } from './pages';
import { OrderDetailPage } from './pages/orders/OrderDetailPage';
import { OrderPalletPreviewPage } from './pages/orders/OrderPalletPreviewPage';
import { SettingsPage } from './pages';
import { ProductsPage, PackagingContainersPage } from './pages';
import { UsersPage, UserFormPage, RolesPage } from './pages';
import { PrintersPage } from './pages';
import { OAuthClientsPage } from './pages';
import { FarmersPage } from './pages';
import { CustomersPage } from './pages';
import { IntakesPage, IntakesSettingsPage } from './pages/intakes';
import { RoutesPage, VehiclesPage, DriversPage, PalletTypesPage } from './pages/logistics';
import { LoadingPlanView } from './pages/loading-plans/LoadingPlanView';
import { LoadingPlansList } from './pages/loading-plans/LoadingPlansList';
import { ProductionDashboard } from './pages';
import { MaintenancePage } from './pages/maintenance/MaintenancePage';
import { AreasListPage } from './pages/maintenance/areas/AreasListPage';
import { EquipmentListPage } from './pages/maintenance/equipment/EquipmentListPage';
import { EquipmentDetailPage } from './pages/maintenance/equipment/EquipmentDetailPage';
import { TasksListPage } from './pages/maintenance/tasks/TasksListPage';
import { CalendarPage } from './pages/maintenance/calendar/CalendarPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { AuditLogsPage } from './pages';
import { ProfilePage } from './pages';
import { OrderForm } from './pages/orders/components/OrderForm';
import { TooltipProvider } from './components/ui/tooltip';
import { useVersionCheck } from './hooks/useVersionCheck';

function App() {
  // Auto-reload when new version is detected
  useVersionCheck();
  
  return (
    <TooltipProvider delayDuration={300} skipDelayDuration={100}>
      <AuthProvider>
      <NotificationProvider>
      <PageConfigProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/iniciar-sesion" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <AuthenticatedRoute>
                <Layout />
              </AuthenticatedRoute>
            }
          >
            <Route index element={<Navigate to="/comandas" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="comandas" element={<OrdersPage />} />
            <Route path="comandas/estadisticas" element={<OrderStatistics />} />
            <Route path="comandas/:id" element={<OrderDetailPage />} />
            <Route path="comandas/ajustes" element={<OrdersSettingsPage />} />
            <Route path="comandas/nueva" element={<OrderForm />} />
            <Route path="comandas/editar/:id" element={<OrderForm />} />
            <Route path="productos" element={<ProductsPage />} />
            <Route path="productos/envases" element={<PackagingContainersPage />} />

            <Route path="usuarios" element={<UsersPage />} />
            <Route path="usuarios/nuevo" element={<UserFormPage />} />
            <Route path="usuarios/editar/:id" element={<UserFormPage />} />
            <Route path="usuarios/roles" element={<RolesPage />} />
            <Route path="impresoras" element={<PrintersPage />} />
            <Route path="agricultores" element={<FarmersPage />} />
            <Route path="partidas" element={<IntakesPage />} />
            <Route path="partidas/ajustes" element={<IntakesSettingsPage />} />
            <Route path="clientes" element={<CustomersPage />} />
            <Route path="logistica" element={<Navigate to="/logistica/rutas" replace />} />
            <Route path="logistica/rutas" element={<RoutesPage />} />
            <Route path="logistica/vehiculos" element={<VehiclesPage />} />
            <Route path="logistica/conductores" element={<DriversPage />} />
            <Route path="logistica/planes-carga" element={<LoadingPlansList />} />
            <Route path="logistica/planes-carga/:id" element={<LoadingPlanView />} />
            <Route path="logistica/tipos-palet" element={<PalletTypesPage />} />

            <Route path="produccion" element={<ProductionDashboard />} />
            <Route path="mantenimiento" element={<MaintenancePage />}>
              <Route index element={<Navigate to="/mantenimiento/tareas" replace />} />
              <Route path="tareas" element={<TasksListPage />} />
              <Route path="equipos" element={<EquipmentListPage />} />
              <Route path="equipos/:slug" element={<EquipmentDetailPage />} />
              <Route path="areas" element={<AreasListPage />} />
              <Route path="calendario" element={<CalendarPage />} />
            </Route>
            <Route path="auditoria" element={<AuditLogsPage />} />
            <Route path="perfil" element={<ProfilePage />} />
            <Route path="configuracion" element={<SettingsPage />} />
            <Route path="configuracion/clientes-oauth" element={<OAuthClientsPage />} />
          </Route>
          <Route path="comandas/:id/preview" element={<OrderPalletPreviewPage />} />
          <Route path="*" element={<Navigate to="/iniciar-sesion" replace />} />
        </Routes>
      </BrowserRouter>
    </PageConfigProvider>
    </NotificationProvider>
    </AuthProvider>
    </TooltipProvider>
  );
}

export default App;
